import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { EmailSentScenario } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EmailSentWaitingView";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { ErrorMessage } from "@faire/web--source/messenger/components/ErrorMessage";
import { Button } from "@faire/web--source/slate/Button";
import { Column, HorizontalLine } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import login from "@faire/web-api--source/api/v2/users/login/post";
import { trackSigninCheckEmailEnterCodeClick } from "@faire/web-api--source/events/signin/click/checkEmailEnterCode";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { LoginState } from "@faire/web-api--source/indigofair/data/LoginState";
import { MfaMethod } from "@faire/web-api--source/indigofair/data/MfaMethod";
import * as React from "react";
export var CommonFooter = function(param) {
    var onComplete = param.onComplete, email = param.email, scenario = param.scenario, password = param.password;
    var shouldDoMagicLink = scenario === EmailSentScenario.MAGIC_LINK || scenario === EmailSentScenario.AUTO;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "3x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "qfDMlv",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Using another device to sign in? "
                        },
                        {
                            type: 8,
                            value: "LinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Enter code"
                                }
                            ]
                        }
                    ],
                    values: {
                        LinkFormatting: LinkFormatting(function() {
                            trackSigninCheckEmailEnterCodeClick(scenario);
                            onComplete(shouldDoMagicLink ? {
                                nextView: View.ENTER_CODE,
                                email: email
                            } : {
                                nextView: View.ENTER_MFA_CODE,
                                email: email,
                                mfaMethod: MfaMethod.EMAIL_ADDRESS,
                                mfaTitle: "",
                                mfaDescription: "",
                                password: password
                            });
                        })
                    }
                })
            })
        ]
    });
};
var LinkFormatting = function(onClick) {
    return function LinkFormatting(chunks) {
        return /*#__PURE__*/ _jsx(Button, {
            variant: "tertiary",
            onClick: onClick,
            tertiaryColor: "inherit",
            children: chunks
        });
    };
};
var OptionBlock = function(param) {
    var title = param.title, method = param.method, onClick = param.onClick;
    return /*#__PURE__*/ _jsxs(Column, {
        onClick: onClick,
        className: "border-core-border-muted border-1 cursor-pointer rounded-lg border px-6 py-5",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: title
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                style: {
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap"
                },
                children: method
            })
        ]
    });
};
export var MFAOptionsFooter = function(param) {
    var email = param.email, scenario = param.scenario, onComplete = param.onComplete, mfaOptionsMemoized = param.mfaOptionsMemoized, password = param.password, userToken = param.userToken;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useSSOStore = useSSOStore(), isActive = _useSSOStore.isActive, ssoToken = _useSSOStore.ssoToken;
    var _React_useState = _sliced_to_array(React.useState(undefined), 2), error = _React_useState[0], setError = _React_useState[1];
    if (!mfaOptionsMemoized) {
        return /*#__PURE__*/ _jsx(CommonFooter, {
            email: email,
            scenario: scenario,
            onComplete: onComplete
        });
    }
    var getName = function(method) {
        if (method === "EMAIL_ADDRESS") {
            return strictLocalize({
                id: "QIMqRe",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Email me a link"
                    }
                ]
            });
        } else if (method === "SMS") {
            return strictLocalize({
                id: "bJMcQ2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Text me a code"
                    }
                ]
            });
        }
        return "";
    };
    var onClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(value, method) {
            var request, _ref, mfa_title, mfa_description, login_state, error, _convertErrorToLoginError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!method || !value) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        request = isActive ? ILoginRequest.build({
                            mfa_method: method,
                            sso_token: ssoToken,
                            password: password,
                            enable_mfa_method_selection: true
                        }) : ILoginRequest.build({
                            password: password,
                            email_address: email,
                            user_token: !email ? userToken : undefined,
                            mfa_method: method,
                            enable_mfa_method_selection: true
                        });
                        return [
                            4,
                            login(request)
                        ];
                    case 2:
                        _ref = _state.sent(), mfa_title = _ref.mfa_title, mfa_description = _ref.mfa_description, login_state = _ref.login_state;
                        if (login_state === LoginState.MFA_REQUIRED) {
                            if (method === MfaMethod.SMS) {
                                return [
                                    2,
                                    onComplete === null || onComplete === void 0 ? void 0 : onComplete({
                                        nextView: View.ENTER_MFA_CODE,
                                        email: email,
                                        userToken: userToken,
                                        mfaMethod: method,
                                        mfaTitle: mfa_title,
                                        mfaDescription: mfa_description,
                                        password: password
                                    })
                                ];
                            } else if (method === MfaMethod.EMAIL_ADDRESS) {
                                return [
                                    2,
                                    onComplete === null || onComplete === void 0 ? void 0 : onComplete({
                                        nextView: View.MFA_OPTIONS_EMAIL_SENT,
                                        email: email,
                                        mfaTitle: mfa_title,
                                        mfaDescription: mfa_description,
                                        password: password
                                    })
                                ];
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setError((_convertErrorToLoginError = convertErrorToLoginError(error, strictLocalize)) === null || _convertErrorToLoginError === void 0 ? void 0 : _convertErrorToLoginError.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClick(value, method) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(Column, {
        gap: "1x",
        children: [
            mfaOptionsMemoized.map(function(param) {
                var value = param.value, method = param.method;
                return /*#__PURE__*/ _jsx(OptionBlock, {
                    title: getName(method),
                    method: value,
                    onClick: function() {
                        return method ? onClick(value, method) : undefined;
                    }
                }, method);
            }),
            error ? /*#__PURE__*/ _jsx(ErrorMessage, {
                message: error
            }) : null
        ]
    });
};
